import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import store from "@/store";
import { Mutations, Actions } from "@/store/enums/StoreEnums";
import Permission from "@/core/config/Permission";
import axios from "axios";

function getCookie(name: string): string | null {
  const nameLenPlus = name.length + 1;
  return (
    document.cookie
      .split(";")
      .map((c) => c.trim())
      .filter((cookie) => {
        return cookie.substring(0, nameLenPlus) === `${name}=`;
      })
      .map((cookie) => {
        return decodeURIComponent(cookie.substring(nameLenPlus));
      })[0] || null
  );
}
function delete_cookie(name) {
  document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
}
function setCookie(name, value, days) {
  delete_cookie(name);
  let expires = "";
  if (days) {
    let date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}
export function checkRole(to) {
  const value = to.meta.role;
  const temp = window.localStorage.getItem("user");
  const user = temp ? JSON.parse(temp) : ({} as any);
  const { role } = user;
  if (checkRoleIsAdmin()) {
    return true
  }
  if (role) {
    if (value && value instanceof Array) {
      if (value.length > 0) {
        const permissionRoles = value;
        // meta.role là mảng SỐ, users.role là CHUỖI số -> ép Number (includes so ===)
        const hasPermission = permissionRoles.includes(Number(role));
        return hasPermission;
      }
    } else {
      return false;
    }
  }
  return false;
}
export function checkRoleIsAdmin() {
  const value = [1, 3];
  const temp = window.localStorage.getItem("user");
  const user = temp ? JSON.parse(temp) : ({} as any);
  const { role } = user;
  if (role) {
    if (value && value instanceof Array) {
      if (value.length > 0) {
        const permissionRoles = value;
        // users.role lưu dạng CHUỖI số ("1"/"3") — includes so ===, phải ép Number
        // kẻo admin mất bypass -> v-permission ẩn nhầm chức năng (Xét trúng tuyển, Xóa hồ sơ...);
        // vẫn nhận giá trị legacy lưu TÊN role (dữ liệu cũ trước khi chuẩn hóa id)
        const hasPermission = permissionRoles.includes(Number(role))
          || ['admin', 'superadmin'].includes(String(role).toLowerCase());
        return hasPermission;
      }
    } else {
      return false;
    }
  }
  return false;
}

// CHỈ superadmin (users.role = id của permission, seed id 1 = 'superadmin').
// Khác checkRoleIsAdmin: admin (id 3) KHÔNG qua được — dùng cho Backups / Logs hệ thống.
// Quyền thật vẫn do backend gác (middleware requireSuperAdmin).
export function checkRoleIsSuperAdmin() {
  const temp = window.localStorage.getItem("user");
  const user = temp ? JSON.parse(temp) : ({} as any);
  const { role } = user;
  if (!role) {
    return false;
  }
  return Number(role) === 1 || String(role).toLowerCase() === "superadmin";
}

export function checkPermission(to) {
  const value = to.meta.permission;
  const temp = window.localStorage.getItem("user");
  const user = temp ? JSON.parse(temp) : (undefined as any);
  const listPermission = user?.permissions?.filter(
    (item) => item.name == value[1]
  );
  if (checkRoleIsAdmin()) {
    return true
  }
  if (listPermission && listPermission.length != 0) {
    const { permissions } = listPermission[0];
    if (permissions && permissions instanceof Array) {
      if (value && value instanceof Array) {
        if (value.length > 0) {
          const permissionRoles = [value[0]];
          const hasPermission = permissions.some((role) => {
            return permissionRoles.includes(role);
          });
          return hasPermission; //true | false
        }
      } else {
        return false;
      }
    }
  } else {
    return false;
  }
}
const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "index",
    //component: () => import("@/views/index.vue"),
    //component: () => import("@/layout/LayoutforOutsite.vue"),
    redirect: "/dashboard",
    children: [
      {
        path: "/dangkyxettuyen",
        name: "dangkyxettuyen",
        component: () => import("@/views/crafted/pages/dangkytuyensinh.vue"),
      },
      {
        path: "/hosocuatoi",
        name: "hosocuatoi",
        component: () => import("@/views/crafted/pages/hosocuatoi.vue"),
      },
      {
        path: "/thutucnhaphoc",
        name: "thutucnhaphoc",
        component: () => import("@/views/crafted/pages/thutucnhaphoc.vue"),
      },
      {
        path: "/tracuuketqua",
        name: "tracuuketqua",
        component: () => import("@/views/crafted/pages/tracuuketqua.vue"),
      },
    ],
  },

  {
    path: "/redirect",
    name: "redirect",
    beforeEnter: async (to, from) => {
      let isAuth = false;
      let err = "";
      let param = "";
      if (process.env.VUE_APP_LOCAL) {
        param = "&target=local";
      }
      if (to.query.code) {
        await axios
          .get(
            `/auth2/redirect?code=${to.query.code}&client_info=${to.query.client_info}&session_state=${to.query.session_state}${param}`
          )
          .then(({ data }) => {
            isAuth = data.isAuthenticated;
            if (data.isAuthenticated) {
              setCookie("accessToken", data.tokens.accessToken, 30);
              store.commit(Mutations.SET_USER_DATA, data.userData);
            }
          })
          .catch(({ response }) => {
            console.log("err", response);
            // Lấy lý do THẬT từ backend (vd "Tài khoản đã bị vô hiệu hóa", "Bạn chỉ là khách...") để
            // hiện thông báo ở trang đăng nhập, thay vì âm thầm quay lại form không nói gì.
            const em = response?.data?.errorMessage || response?.data?.message;
            err = (Array.isArray(em) ? em.join(", ") : em) || "Đăng nhập không thành công. Vui lòng thử lại.";
          });
      } else if (to.query.error) {
        err = "Đăng nhập không thành công. Email không hợp lệ hoặc chưa được cấp quyền truy cập.";
      }
      return isAuth
        ? router.push({ path: "/dashboard" })
        : router.push({ path: "/dangnhap", query: err ? { err: err } : {} });
    },
    //redirect: "/dashboard",
    component: () => import("@/layout/Layout.vue"),
  },
  {
    path: "/signout",
    name: "signout",
    beforeEnter: async (to, from) => {
      let temp = window.localStorage.getItem("user");
      let user = temp ? JSON.parse(temp) : null;
      let id = user?.id;
      axios.post("/auth2/signout", { userId: id });
      delete_cookie("accessToken");
      window.localStorage.removeItem("user");
      router.push({ path: "/dangnhap" });
    },
    component: () => import("@/layout/Layout.vue"),
  },
  {
    path: "/dashboard",
    name: "dashboard",
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "/dashboard",
        name: "dashboard1",
        component: () => import("@/views/Dashboard.vue"),
        beforeEnter: async (to) => {
          let permission = checkPermission(to);
          return permission
            ? permission
            : router.push({ path: "/danhsachhoso" });
        },
        meta: {
          permission: [Permission.DASHBOARD_VIEW, Permission.DASHBOARD],
        },
      },
      {
        path: "/danhsachdangkykiemtratienganh",
        component: () => import("@/views/apps/englishRegistration.vue"),
      },
      {
        path: "/danhsachdiaphuong",
        name: "danhsachdiaphuong",
        component: () => import("@/views/apps/listForLocals.vue"),
      },
      {
        path: "/danhsachdiaphuong/:id",
        name: "danhsachchitietdiaphuong",
        component: () => import("@/views/apps/listForLocalDetail.vue"),
      },
      {
        path: "/danhsachtruong",
        name: "danhsachtruong",
        component: () => import("@/views/apps/listForSchools.vue"),
      },
      {
        path: "/danhsachtruong/:id",
        name: "danhsachchitiettruong",
        component: () => import("@/views/apps/listForSchoolDetail.vue"),
      },
      {
        path: "/danhsachungvien",
        name: "danhsachungvien",
        component: () => import("@/views/apps/candidateList.vue"),
        beforeEnter: async (to) => {
          let permission = checkPermission(to);
          return permission ? permission : router.push({ path: "/hosocanhan" });
        },
        meta: {
          permission: [Permission.STUDENT_VIEW, Permission.STUDENT],
        },
      },
      {
        //Đồng bộ Bộ GD&ĐT: đối soát NV + điền điểm từ học bạ khớp Bộ + lịch sử (import điểm vẫn ở DS ứng viên)
        path: "/dongbobgd",
        name: "dongbobgd",
        component: () => import("@/views/apps/bgdSync.vue"),
        beforeEnter: async (to) => {
          let permission = checkPermission(to);
          return permission ? permission : router.push({ path: "/hosocanhan" });
        },
        meta: {
          permission: [Permission.STUDENT_BGD_SYNC, Permission.STUDENT],
        },
      },
      {
        path: "/danhsachdangkylienthong",
        name: "danhsachdangkylienthong",
        component: () => import("@/views/apps/intermediateList.vue"),
        beforeEnter: async (to) => {
          let permission = checkPermission(to);
          return permission ? permission : router.push({ path: "/hosocanhan" });
        },
        meta: {
          permission: [Permission.STUDENT_VIEW, Permission.STUDENT],
        },
      },

      {
        path: "/quanlyungvien",
        name: "quanlyungvien",
        component: () => import("@/views/apps/candidateListforAssignee.vue"),
        beforeEnter: async (to) => {
          let role = checkRole(to);
          return role ? role : router.push({ path: "/403" });
        },
        meta: {
          role: [1, 3],
        },
      },
      {
        path: "/danhsachhoso",
        name: "danhsachhoso",
        component: () => import("@/views/apps/profileList.vue"),
        beforeEnter: async (to) => {
          let permission = checkPermission(to);
          return permission ? permission : router.push({ path: "/hosocanhan" });
        },
        meta: {
          permission: [
            Permission.ADMISSION_REGISTER_VIEW,
            Permission.ADMISSION_REGISTER,
          ],
        },
      },
      {
        path: "/hosoungvien/:id",
        component: () => import("@/views/apps/profileDetail.vue"),
        beforeEnter: async (to) => {
          let permission = checkPermission(to);
          return permission ? permission : router.push({ path: "/hosocanhan" });
        },
        meta: {
          permission: [
            Permission.ADMISSION_REGISTER_VIEW_DETAIL,
            Permission.ADMISSION_REGISTER,
          ],
        },
      },
      {
        path: "/danhsachhocbong",
        name: "danhsachhocbong",
        component: () => import("@/views/apps/scholarshipList.vue"),
        beforeEnter: async (to) => {
          let permission = checkPermission(to);
          return permission ? permission : router.push({ path: "/hosocanhan" });
        },
        meta: {
          permission: [
            Permission.SCHOLARSHIP_VIEW,
            Permission.SCHOLARSHIP,
          ],
        },
      },
      // Route /danhsachhocbong/:id + /themhocbong (page scholarshipAdd) đã gỡ —
      // xem/sửa học bổng đã cấp chuyển sang drawer ngay trong danh sách (ScholarshipGrantDrawer).
      {
        // Trang Thêm hồ sơ xét tuyển cho 1 ứng viên (:id = idStudent) — thay modal Thêm hồ sơ cũ
        path: "/themhoso/:id",
        name: "themhoso",
        component: () => import("@/views/apps/profileAdd.vue"),
        beforeEnter: async (to) => {
          let permission = checkPermission(to);
          return permission ? permission : router.push({ path: "/hosocanhan" });
        },
        meta: {
          permission: [Permission.ADMISSION_REGISTER_CREATE, Permission.ADMISSION_REGISTER],
        },
      },
      {
        // Trang Thêm hồ sơ LIÊN THÔNG (LTĐHCQ) cho 1 ứng viên (:id = idStudent)
        path: "/themhosolienthong/:id",
        name: "themhosolienthong",
        component: () => import("@/views/apps/profileAddArticulation.vue"),
        beforeEnter: async (to) => {
          let permission = checkPermission(to);
          return permission ? permission : router.push({ path: "/hosocanhan" });
        },
        meta: {
          permission: [Permission.ADMISSION_REGISTER_CREATE, Permission.ADMISSION_REGISTER],
        },
      },
      {
        path: "/danhsachdangkyhocbong",
        name: "danhsachdangkyhocbong",
        component: () => import("@/views/apps/registerScholarshipList.vue"),
        beforeEnter: async (to) => {
          let permission = checkPermission(to);
          return permission ? permission : router.push({ path: "/hosocanhan" });
        },
        meta: {
          permission: [
            Permission.SCHOLARSHIP_VIEW,
            Permission.SCHOLARSHIP,
          ],
        },
      },
      {
        path: "/dangkyhocbong/:id",
        component: () => import("@/views/apps/registerScholarshipAdd.vue"),
        beforeEnter: async (to) => {
          let permission = checkPermission(to);
          return permission ? permission : router.push({ path: "/hosocanhan" });
        },
        meta: {
          permission: [
            Permission.SCHOLARSHIP_VIEW,
            Permission.SCHOLARSHIP,
          ],
        },
      },

      {
        path: "/dangkyhocbong",
        name: "dangkyhocbong",
        component: () => import("@/views/apps/registerScholarshipAdd.vue"),
        beforeEnter: async (to) => {
          let permission = checkPermission(to);
          return permission ? permission : router.push({ path: "/hosocanhan" });
        },
        meta: {
          permission: [Permission.SCHOLARSHIP_CREATE, Permission.SCHOLARSHIP],
        },
      },
      {
        path: "/hosoluutru",
        name: "hosoluutru",
        component: () => import("@/views/apps/profileArchived.vue"),
        beforeEnter: async (to) => {
          let permission = checkPermission(to);
          return permission ? permission : router.push({ path: "/hosocanhan" });
        },
        meta: {
          permission: [
            Permission.ADMISSION_REGISTER_VIEW,
            Permission.ADMISSION_REGISTER,
          ],
        },
      },
      {
        path: "/hosoluutru/:id",
        component: () => import("@/views/apps/profileDetail.vue"),
        beforeEnter: async (to) => {
          let permission = checkPermission(to);
          return permission ? permission : router.push({ path: "/hosocanhan" });
        },
        meta: {
          permission: [
            Permission.ADMISSION_REGISTER_VIEW_DETAIL,
            Permission.ADMISSION_REGISTER,
          ],
        },
      },
      {
        path: "/danhsachungvien/:id",
        component: () => import("@/views/apps/candidateListDetail.vue"),
        beforeEnter: async (to) => {
          let permission = checkPermission(to);
          return permission ? permission : router.push({ path: "/hosocanhan" });
        },
        meta: {
          permission: [Permission.STUDENT_VIEW_DETAIL, Permission.STUDENT],
        },
      },
      {
        path: "/themungvien",
        name: "themungvien",
        component: () => import("@/views/apps/candidateAdd.vue"),
        beforeEnter: async (to) => {
          let permission = checkPermission(to);
          return permission ? permission : router.push({ path: "/hosocanhan" });
        },
        meta: {
          permission: [Permission.STUDENT_CREATE, Permission.STUDENT],
        },
      },
      {
        path: "/danhsachhosodaxoa",
        name: "danhsachhosodaxoa",
        component: () => import("@/views/apps/profileListToDelete.vue"),
        beforeEnter: async (to) => {
          let permission = checkPermission(to);
          return permission ? permission : router.push({ path: "/hosocanhan" });
        },
        meta: {
          permission: [
            Permission.ADMISSION_REGISTER_VIEW_DELETE,
            Permission.ADMISSION_REGISTER,
          ],
        },
      },
      {
        path: "/danhsachungviendaxoa",
        name: "danhsachungviendaxoa",
        component: () => import("@/views/apps/candidateListToDelete.vue"),
        beforeEnter: async (to) => {
          let permission = checkPermission(to);
          return permission ? permission : router.push({ path: "/hosocanhan" });
        },
        meta: {
          permission: [Permission.STUDENT_VIEW_DELETE, Permission.STUDENT],
        },
      },
      {
        path: "/tracuukhuvucuutien",
        name: "tracuukhuvucuutien",
        component: () => import("@/views/crafted/pages/tracuukhuvucuutien.vue"),
      },
      {
        path: "/chiendichmailmarketing",
        name: "chiendichmailmarketing",
        component: () => import("@/views/apps/customEmailCampaigns.vue"),
        beforeEnter: async (to) => {
          let permission = checkPermission(to);
          return permission ? permission : router.push({ path: "/hosocanhan" });
        },
        meta: {
          permission: [Permission.MARKETING_VIEW, Permission.MARKETING],
        },
      },
      {
        path: "/exportdanhsach",
        name: "exportdanhsach",
        component: () => import("@/views/apps/exportStudentaffairs.vue"),
        beforeEnter: async (to) => {
          let permission = checkPermission(to);
          return permission ? permission : router.push({ path: "/hosocanhan" });
        },
        meta: {
          permission: [Permission.STUDENTAFFAIRS_VIEW, Permission.STUDENTAFFAIRS],
        },
      },
      {
        path: "/groups",
        name: "groups",
        component: () => import("@/views/apps/tools/templateGroups.vue"),
        beforeEnter: async (to) => {
          let role = checkRole(to);
          return role ? role : router.push({ path: "/403" });
        },
        meta: {
          role: [1, 3],
        },
      },

      {
        path: "/chiendichmailmarketing/:id",
        name: "chitietchiendichmailmarketing",
        component: () => import("@/views/apps/detailCustomEmailCampaigns.vue"),
        beforeEnter: async (to) => {
          let permission = checkPermission(to);
          return permission ? permission : router.push({ path: "/hosocanhan" });
        },
        meta: {
          permission: [Permission.MARKETING_VIEW, Permission.MARKETING],
        },
      },
      {
        path: "/mauemail",
        name: "mauemail",
        component: () => import("@/views/apps/tools/templateMail.vue"),
        beforeEnter: async (to) => {
          let permission = checkPermission(to);
          return permission ? permission : router.push({ path: "/hosocanhan" });
        },
        meta: {
          permission: [Permission.APPLICANT_VIEW_DETAIL, Permission.APPLICANT],
        },
      },
      {
        // Công cụ: Rà soát ưu đãi cấp-trước / quá hạn (oversight, chỉ đọc)
        path: "/rasoatuudai",
        name: "rasoatuudai",
        component: () => import("@/views/apps/tools/reviewPromotionAdvance.vue"),
        beforeEnter: async (to) => {
          let permission = checkPermission(to);
          return permission ? permission : router.push({ path: "/hosocanhan" });
        },
        meta: {
          permission: [Permission.SCHOLARSHIP_REVIEW_ADVANCE, Permission.SCHOLARSHIP],
        },
      },
      {
        path: "/hosocanhan",
        name: "hosocanhan",
        component: () => import("@/views/apps/myprofile.vue"),
      },
      {
        path: "/settings",
        name: "settings",
        component: () => import("@/views/apps/settings.vue"),
        beforeEnter: async (to) => {
          let role = checkRole(to);
          return role ? role : router.push({ path: "/403" });
        },
        meta: {
          role: [1],
        },
      },
      {
        path: "/permission",
        name: "permission",
        component: () => import("@/views/apps/superAdmin/permissions.vue"),
        beforeEnter: async (to) => {
          let role = checkRole(to);
          return role ? role : router.push({ path: "/hosocanhan" });
        },
        meta: {
          role: [1],
        },
      },
      {
        path: "/sms-config",
        name: "sms-config",
        component: () => import("@/views/apps/superAdmin/smsConfig.vue"),
        beforeEnter: async (to) => {
          let role = checkRole(to);
          return role ? role : router.push({ path: "/hosocanhan" });
        },
        meta: {
          role: [1],
        },
      },
      {
        path: "/api-keys",
        name: "api-keys",
        component: () => import("@/views/apps/superAdmin/apiKeys.vue"),
        beforeEnter: async (to) => {
          let role = checkRole(to);
          return role ? role : router.push({ path: "/hosocanhan" });
        },
        meta: {
          role: [1],
        },
      },
      {
        path: "/integrations",
        name: "integrations",
        component: () => import("@/views/apps/superAdmin/integrations.vue"),
        beforeEnter: async (to) => {
          let role = checkRole(to);
          return role ? role : router.push({ path: "/hosocanhan" });
        },
        meta: {
          role: [1],
        },
      },
      {
        path: "/purgedeleted",
        name: "purgedeleted",
        component: () => import("@/views/apps/superAdmin/deleteData.vue"),
        beforeEnter: async (to) => {
          let role = checkRole(to);
          return role ? role : router.push({ path: "/hosocanhan" });
        },
        meta: {
          role: [1],
        },
      },
      {
        path: "/generalsettings",
        name: "generalsettings",
        component: () => import("@/views/apps/superAdmin/generalsettings.vue"),
        beforeEnter: async (to) => {
          let role = checkRole(to);
          return role ? role : router.push({ path: "/hosocanhan" });
        },
        meta: {
          role: [1],
        },
      },
      {
        path: "/unmapped-lead-owners",
        name: "unmapped-lead-owners",
        component: () => import("@/views/apps/superAdmin/unmappedLeadOwners.vue"),
        beforeEnter: async (to) => {
          let role = checkRole(to);
          return role ? role : router.push({ path: "/hosocanhan" });
        },
        meta: {
          role: [1],
        },
      },
      {
        path: "/assignee-history",
        name: "assignee-history",
        component: () => import("@/views/apps/AssigneeHistory.vue"),
        beforeEnter: async (to) => {
          let role = checkRole(to);
          return role ? role : router.push({ path: "/hosocanhan" });
        },
        meta: {
          role: [1, 3],
        },
      },
      {
        path: "/roundrobin-health",
        name: "roundrobin-health",
        component: () => import("@/views/apps/superAdmin/roundrobinHealth.vue"),
        beforeEnter: async (to) => {
          let role = checkRole(to);
          return role ? role : router.push({ path: "/hosocanhan" });
        },
        meta: {
          role: [1],
        },
      },
      {
        path: "/backups",
        name: "backups",
        component: () => import("@/views/apps/superAdmin/backups.vue"),
        beforeEnter: async () => {
          //chỉ superadmin — admin(3) cũng bị chặn nên không dùng checkRole
          return checkRoleIsSuperAdmin() ? true : router.push({ path: "/403" });
        },
      },
      {
        path: "/logs",
        name: "logs",
        component: () => import("@/views/apps/superAdmin/logs.vue"),
        beforeEnter: async () => {
          return checkRoleIsSuperAdmin() ? true : router.push({ path: "/403" });
        },
      },
      {
        path: "/unassigned-applicants",
        name: "unassigned-applicants",
        component: () => import("@/views/apps/superAdmin/unassignedApplicants.vue"),
        beforeEnter: async (to) => {
          let role = checkRole(to);
          return role ? role : router.push({ path: "/hosocanhan" });
        },
        meta: {
          role: [1, 3],
        },
      },

      {
        path: "/danhsachxettuyen",
        name: "danhsachxettuyen",
        component: () => import("@/views/apps/enrollmentList.vue"),
      },
      {
        path: "/dukiendiemchuan",
        name: "dukiendiemchuan",
        component: () => import("@/views/apps/expectedBenchmark.vue"),
      },
      {
        path: "/xettrungtuyen",
        name: "xettrungtuyen",
        component: () => import("@/views/apps/matriculationList.vue"),
      },
      {
        path: "/xettuyenthang",
        name: "xettuyenthang",
        component: () => import("@/views/apps/admissionDirect.vue"),
      },
      {
        path: "/xettuyenlienthong",
        name: "xettuyenlienthong",
        component: () => import("@/views/apps/admissionIntermediate.vue"),
      },
      {
        path: "/ketquatuyensinh",
        name: "ketquatuyensinh",
        component: () => import("@/views/apps/admissionResults.vue"),
      },
      {
        path: "/ketquatuyensinhlienthong",
        name: "ketquatuyensinhlienthong",
        component: () => import("@/views/apps/admissionResultsLienthong.vue"),
      },

      {
        path: "/danhsachtrungtuyen",
        name: "danhsachtrungtuyen",
        component: () => import("@/views/apps/listAdmissionResults.vue"),
      },
      // /danhsachtrungtuyenlienthong đã GỠ (2026-07-04): trang Danh sách trúng tuyển chứa cả liên thông
      // (lọc bằng filter Phương thức) — trang riêng là bản trùng lặp.
      {
        path: "/importmatriculationList",
        name: "importmatriculationList",
        component: () => import("@/views/apps/importMatriculationList.vue"),
      },
      {
        path: "/caidatxettuyen",
        name: "caidatxettuyen",
        component: () => import("@/views/apps/admissionSettings.vue"),
      },
      {
        path: "/schools",
        name: "schools",
        component: () => import("@/views/apps/schoolsManager.vue"),
      },
      {
        path: "/lead-routing",
        name: "lead-routing",
        component: () => import("@/views/apps/LeadRouting.vue"),
        beforeEnter: async (to) => {
          let role = checkRole(to);
          return role ? role : router.push({ path: "/403" });
        },
        meta: {
          role: [1, 3],
        },
      },
      {
        path: "/danhsachthutucnhaphoc",
        name: "danhsachthutucnhaphoc",
        component: () => import("@/views/apps/admissionProcedureList.vue"),
        beforeEnter: async (to) => {
          let permission = checkPermission(to);
          return permission ? permission : router.push({ path: "/hosocanhan" });
        },
        meta: {
          permission: [Permission.APPLICANT_VIEW, Permission.APPLICANT],
        },
      },
      {
        path: "/danhsachthutucnhaphoc/:id",
        component: () =>
          import("@/views/apps/admissionProcedureListDetail.vue"),
        beforeEnter: async (to) => {
          let permission = checkPermission(to);
          return permission ? permission : router.push({ path: "/hosocanhan" });
        },
        meta: {
          permission: [Permission.APPLICANT_VIEW_DETAIL, Permission.APPLICANT],
        },
      },
      {
        path: "/themthutucnhaphoc",
        name: "themthutucnhaphoc",
        component: () => import("@/views/apps/admissionProcedureAdd.vue"),
        beforeEnter: async (to) => {
          let permission = checkPermission(to);
          return permission ? permission : router.push({ path: "/hosocanhan" });
        },
        meta: {
          permission: [Permission.SETTING_CREATE, Permission.SETTING],
        },
      },
      {
        path: "/danhsachdongbosis",
        name: "danhsachdongbosis",
        component: () => import("@/views/apps/asyncSIS.vue"),
        beforeEnter: async (to) => {
          let permission = checkPermission(to);
          return permission ? permission : router.push({ path: "/hosocanhan" });
        },
        meta: {
          permission: [Permission.APPLICANT_VIEW, Permission.APPLICANT],
        },
      },
      {
        path: "/danhsachsinhvienmienhp",
        name: "danhsachsinhvienmienhp",
        component: () => import("@/views/apps/exemptCoursesList.vue"),
        beforeEnter: async (to) => {
          let role = checkRole(to);
          return role ? role : router.push({ path: "/403" });
        },
        meta: {
          role: [1],
        },
      },
      {
        path: "/lapphieuthu",
        name: "lapphieuthu",
        beforeEnter: async (to) => {
          let permission = checkPermission(to);
          return permission ? permission : router.push({ path: "/hosocanhan" });
        },
        meta: {
          permission: [Permission.ACCOUNTANT_VIEW, Permission.ACCOUNTANT],
        },
        component: () => import("@/views/apps/receipts.vue"),
      },
      {
        path: "/caidatthutucnhaphoc",
        name: "caidatthutucnhaphoc",
        component: () => import("@/views/apps/admissionProcedureSettings.vue"),
        beforeEnter: async (to) => {
          let permission = checkPermission(to);
          return permission ? permission : router.push({ path: "/hosocanhan" });
        },
        meta: {
          permission: [Permission.SETTING_EDIT, Permission.SETTING],
        },
      },
      {
        path: "/caidatthutucnhaphoc/hocbong",
        name: "thutuchocbong",
        component: () => import("@/views/apps/procedureSettings/scholarship.vue"),
      },
      {
        path: "/caidatthutucnhaphoc/tienganh",
        name: "thutuctienganh",
        component: () => import("@/views/apps/procedureSettings/freesubject.vue"),
      },
      {
        path: "/caidatthutucnhaphoc/hocphi",
        name: "thutuchocphi",
        component: () => import("@/views/apps/procedureSettings/tuition.vue"),
      },
      {
        path: "/caidatthutucnhaphoc/hocphiBC",
        name: "thutuchocphiBC",
        component: () => import("@/views/apps/procedureSettings/tuitionItemFromBC.vue"),
      },
      {
        path: "/caidatthutucnhaphoc/phikhac",
        name: "thutucphikhac",
        component: () => import("@/views/apps/procedureSettings/freeOther.vue"),
      },
      {
        path: "/caidatthutucnhaphoc/monhoc",
        name: "thutucmonhoc",
        component: () => import("@/views/apps/procedureSettings/subject.vue"),
      },
      {
        path: "/caidatthutucnhaphoc/lophoc",
        name: "danhsachlophoc",
        component: () => import("@/views/apps/procedureSettings/classesList.vue"),
      },
      {
        path: "/caidatthutucnhaphoc/sanphamkhac",
        name: "thutucsanphamkhac",
        component: () => import("@/views/apps/procedureSettings/productOther.vue"),
      },
      {
        path: "/caidatthutucnhaphoc/hinhthucthanhtoan",
        name: "thutuchinhthucthanhtoan",
        component: () => import("@/views/apps/procedureSettings/payment.vue"),
      },
      {
        path: "/caidatthutucnhaphoc/hotrotaichinh",
        name: "thutuchotrotaichinh",
        component: () => import("@/views/apps/procedureSettings/financialsupport.vue"),
      },
      {
        path: "/caidatthutucnhaphoc/chuongtrinhuudai",
        name: "thutucchuongtrinhuudai",
        component: () => import("@/views/apps/procedureSettings/promotion.vue"),
      },
      {
        path: "/caidatthutucnhaphoc/quanlysoseries",
        name: "quanlysoseries",
        component: () => import("@/views/apps/procedureSettings/noSeries.vue"),
      },

      {
        path: "/403",
        name: "403",
        component: () => import("@/views/crafted/authentication/Error403.vue"),
      },
    ],
  },
  {
    path: "/dangnhap",
    name: "dangnhap",
    beforeEnter: async (to, from) => {
      if (getCookie("accessToken")) {
        let temp = window.localStorage.getItem("user");
        let user = temp ? JSON.parse(temp) : null;
        let id = user?.id;
        await axios
          .post(`/auth2/authenticated`, {
            accessToken: getCookie("accessToken"),
            userId: id,
          })
          .then(({ data }) => {
            if (data.isAuthenticated) {
              router.push({ path: "/dashboard" });
            } else {
              delete_cookie("accessToken");
              window.localStorage.removeItem("user");
            }
          })
          .catch(({ response }) => {
            console.log("err", response);
          });
      }
    },

    component: () =>
      import("@/views/crafted/authentication/basic-flow/SignIn.vue"),
  },
  // {
  //   path: "/dangxuat",
  //   name: "dangxuat",
  //   beforeEnter: async (to, from) => {
  //     let temp = window.localStorage.getItem("user")
  //     let user = temp?JSON.parse(temp) : null
  //     let id = user?.id
  //     await axios.post('/auth2/signout',{userId:id})
  //     .then(( {data} ) => {
  //       let path = data.logoutURL
  //       router.push({ path: path })
  //     })
  //   },
  //   component: () => import("@/views/crafted/authentication/basic-flow/SignIn.vue"),
  // },
  {
    path: "/404",
    name: "404",
    component: () => import("@/views/crafted/authentication/Error404.vue"),
  },
  {
    path: "/500",
    name: "500",
    component: () => import("@/views/crafted/authentication/Error500.vue"),
  },
  {
    path: "/phieutiepnhanhoso",
    name: "phieutiepnhanhoso",
    component: () => import("@/views/crafted/pages/phieutiepnhanhoso.vue"),
  },
  {
    path: "/phieudangkyxettuyen",
    name: "phieudangkyxettuyen",
    component: () => import("@/views/crafted/pages/phieudangkyxettuyen.vue"),

  },
  {
    path: "/phieudangkyxettuyenPdf",
    name: "phieudangkyxettuyenPdf",
    component: () => import("@/views/crafted/pages/phieudangkyxettuyen.vue"),
  },
  {
    path: "/thongbaotrungtuyenPdf",
    name: "thongbaotrungtuyenPdf",
    component: () => import("@/views/crafted/pages/thongbaotrungtuyen.vue"),
  },
  {
    path: "/thongbaotrungtuyen",
    name: "thongbaotrungtuyen",
    component: () => import("@/views/crafted/pages/thongbaotrungtuyen.vue"),
    beforeEnter: async (to) => {
      let dataJson;
      await axios
        .get(`/admission/lookup/?adcode=${to.query.adcode}`)
        .then(({ data }) => {
          //
          dataJson = data;
        })
        .catch(({ response }) => {
          console.log("err", response);
        });
      return {
        path: "/thongbaotrungtuyenPdf",
        query: { data: JSON.stringify(dataJson) },
      };
    },
  },
  {
    path: "/phieuthongtinsinhvien",
    name: "phieuthongtinsinhvien",
    component: () =>
      import("@/views/crafted/pages/phieuthongtinsinhvien.vue"),
    beforeEnter: async (to) => {
      let dataJson;
      await axios
        .get(`applicant/${to.query.id}`)
        .then(({ data }) => {
          dataJson = data;
        })
        .catch(({ response }) => {
          console.log("err", response);
        });
      return {
        path: "/phieuthongtinsinhvienPdf",
        query: { data: JSON.stringify(dataJson), autoprint: to.query.autoprint },
      };
    },
  },
  {
    path: "/phieuthongtinsinhvienPdf",
    name: "phieuthongtinsinhvienPdf",
    component: () =>
      import("@/views/crafted/pages/phieuthongtinsinhvien.vue"),
  },
  {
    path: "/phieuthu",
    name: "phieuthu",
    component: () =>
      import("@/views/crafted/pages/phieuthu.vue"),
    beforeEnter: async (to) => {
      let dataJson;
      await axios
        .get(`applicant/${to.query.id}`)
        .then(({ data }) => {
          dataJson = data;
        })
        .catch(({ response }) => {
          console.log("err", response);
        });
      return {
        path: "/phieuthuPdf",
        query: { data: JSON.stringify(dataJson) },
      };
    },
  },
  {
    path: "/phieuxacnhanuudai",
    name: "phieuxacnhanuudai",
    component: () => import("@/views/crafted/pages/phieuxacnhanuudai.vue"),
  },
  {
    path: "/phieuxacnhanhocbong",
    name: "phieuxacnhanhocbong",
    component: () => import("@/views/crafted/pages/phieuxacnhanhocbong.vue"),
  },
  {
    path: "/phieuxacnhanuudaiPdf",
    name: "phieuxacnhanuudaiPdf",
    component: () =>
      import("@/views/crafted/pages/phieuxacnhanuudai.vue"),
  },
  {
    path: "/phieuthuPdf",
    name: "phieuthuPdf",
    component: () =>
      import("@/views/crafted/pages/phieuthu.vue"),
  },
  {
    path: "/phieuxacnhan",
    name: "phieuxacnhan",
    component: () =>
      import("@/views/crafted/pages/phieuxacnhan.vue"),
    beforeEnter: async (to) => {
      let dataJson;
      // console.log('to.query.id',to.query)
      // await axios
      //   .get(`applicant/${to.query.id}`)
      //   .then(({ data }) => {
      //     dataJson = data;
      //   })
      //   .catch(({ response }) => {
      //     console.log("err", response);
      //   });
      return {
        path: "/phieuxacnhanPdf",
        query: { data: JSON.stringify(dataJson) },
      };
    },
  },
  {
    path: "/phieuxacnhanPdf",
    name: "phieuxacnhanPdf",
    component: () =>
      import("@/views/crafted/pages/phieuxacnhan.vue"),
  },
  {
    //Path lạ -> /404. Trước đây không khớp route nào = MÀN TRẮNG câm (vd /backups khi
    //trang Settings đã có card nhưng route chưa được khai báo).
    path: "/:pathMatch(.*)*",
    redirect: "/404",
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

//XÁC THỰC LẠI KHI CHUYỂN TRANG — trước đây guard `await` /auth2/authenticated nên MỖI lần bấm menu
//đều đứng hình chờ 1 vòng mạng + 3 query DB (settings + refresh_tokens + users), có khi còn gọi ra Azure
//để gia hạn token => cảm giác "khựng". Nay:
//  - Lần đầu vào app (mở tab/F5): VẪN CHỜ như cũ — phiên đã hết hiệu lực thì không lóe ra trang nào.
//  - Các lần chuyển trang sau: cho vào ngay, kiểm tra chạy NGẦM (vẫn mỗi lần chuyển trang, không giãn tần suất)
//    -> phiên bị khóa/thu hồi thì vẫn bị đẩy ra đăng nhập, chỉ chậm hơn đúng thời gian request.
//An toàn vì middleware auth0 verify token ở TỪNG API; và auth.js/auth2.js chấp nhận token hết hạn khi
//refresh token còn hiệu lực -> không chờ gia hạn ở đây cũng KHÔNG làm API của trang bị 401.
let _authCheckInflight: Promise<boolean> | null = null;
let _firstAuthCheckDone = false;

//Trả true = phiên còn dùng được (hoặc không kết luận được vì lỗi mạng/BE). Trả false = BE khẳng định hết hiệu lực.
//Gộp request đang bay để bấm menu liên tục không bắn chồng nhiều lời gọi.
function verifyAuthSession(): Promise<boolean> {
  if (_authCheckInflight) {
    return _authCheckInflight;
  }
  const temp = window.localStorage.getItem("user");
  const user = temp ? JSON.parse(temp) : null;
  _authCheckInflight = axios
    .post("/auth2/authenticated", {
      accessToken: getCookie("accessToken"),
      userId: user?.id,
    })
    .then(({ data }) => {
      if (data.isAuthenticated) {
        if (data.newAccessToken) {
          setCookie("accessToken", data.newAccessToken, 30);
        }
        return true;
      }
      //Tài khoản bị vô hiệu hóa / token bị thu hồi -> dọn phiên tại chỗ
      delete_cookie("accessToken");
      window.localStorage.removeItem("user");
      return false;
    })
    .catch((error) => {
      //Lỗi mạng/BE (500, mất kết nối...): KHÔNG đá người dùng ra như trước — token vẫn được kiểm ở từng API
      console.log("verifyAuthSession error", error?.response?.status);
      return true;
    })
    .finally(() => {
      _authCheckInflight = null;
    });
  return _authCheckInflight;
}

router.beforeEach(async (to) => {
  if (
    to.name != "dangkyxettuyen" &&
    to.name != "dangnhap" &&
    to.name != "dangxuat" &&
    to.name != "redirect" &&
    to.name != "tracuuketqua" &&
    to.name != "phieudangkyxettuyen" &&
    to.name != "phieudangkyxettuyenPdf" &&
    to.name != "signout" &&
    to.name != "403" &&
    to.name != "index" &&
    to.name != "hosocuatoi" &&
    to.name != "thutucnhaphoc" &&
    to.name != "thongbaotrungtuyen" &&
    to.name != "thongbaotrungtuyenPdf" &&
    to.name != "phieuthongtinsinhvienPdf" &&
    to.name != "phieuthongtinsinhvien" &&
    to.name != "phieuthu" &&
    to.name != "phieuthuPdf" &&
    to.name != "phieuxacnhan" &&
    to.name != "phieuxacnhanPdf"
  ) {
    //Chưa đăng nhập (không có cookie) -> ra đăng nhập ngay, khỏi gọi API
    if (!getCookie("accessToken")) {
      return router.push({ name: "dangnhap" });
    }
    //Lần đầu vào app: chờ kết quả rồi mới cho vào (giữ nguyên hành vi cũ)
    if (!_firstAuthCheckDone) {
      _firstAuthCheckDone = true;
      const ok = await verifyAuthSession();
      return ok ? true : router.push({ name: "dangnhap" });
    }
    //Chuyển trang trong app: vào ngay, kiểm tra ngầm; hết hiệu lực thì đẩy ra đăng nhập khi có kết quả
    verifyAuthSession().then((ok) => {
      if (!ok && router.currentRoute.value.name !== "dangnhap") {
        router.push({ name: "dangnhap" });
      }
    });
    return true;
  }
  // reset config to initial state
  //store.commit(Mutations.RESET_LAYOUT_CONFIG);

  //store.dispatch(Actions.VERIFY_AUTH);

  // Scroll page to top on every route change
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 100);
});

export default router;
